/** Buttons that trigger onomatopoeia (excludes inputs / mute-flagged). */
export const FX_BUTTON_SELECTOR =
  'button:not([data-fx-mute]), [role="button"]:not([data-fx-mute])';

export const ONO_POOL_SIZE = 6;          // spans pre-allocated for the layer
export const ONO_DURATION_MS = 700;
export const ONO_ANGLE_RANGE_DEG = 15;   // ±15° random tilt

export const FLY_POOL_SIZE = 4;          // <img> nodes pre-allocated
export const FLY_DURATION_MS = 700;
export const CART_BUMP_DURATION_MS = 400;

export const TRAIL_POOL_SIZE = 28;        // sparkle nodes pre-allocated
export const TRAIL_DURATION_MS = 1100;
export const TRAIL_MIN_PX = 26;           // min cursor travel between spawns

export const HOVER_TARGET_SELECTOR =
  'button, a, [role="button"], input[type="submit"], .dish-card--wobble';
